"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationDescription = void 0;
const utils_1 = require("../utils");
exports.OperationDescription = () => {
    return {
        Operation(operation, ctx) {
            utils_1.validateDefinedAndNonEmpty('description', operation, ctx);
        },
    };
};
